export const links = {
  corporateSiteURL: 'https://corporate-site-dot-stemx-228313.ew.r.appspot.com',
  landingSiteURL: 'https://landing-dev.stx.interticket.com',
  streamingSiteURL: 'https://streaming-dev.stx.interticket.com',
};
